import { alpha, Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

export default function PlaceholderPoster({ title, caption, overlay = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        width: "100%",
        height: 0,
        paddingTop: "150%",
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.text.secondary,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -55%)", // vertically center with slight upward shift
          textAlign: "center",
          px: 1,
        }}
      >
        {title && (
          <Typography
            variant={isMobile ? "caption" : "body1"}
            sx={{
              fontWeight: "bold",
              mb: 1,
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              hyphens: "auto",
              lineHeight: {
                xs: 1.2, // tighter lines for "caption"
                sm: 1.4, // default or looser spacing for "body1"
              },
            }}
          >
            {title}
          </Typography>
        )}
        {caption && <Typography variant="caption">{caption}</Typography>}
      </Box>

      {overlay && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: alpha(theme.palette.text.primary, 0.11),
            pointerEvents: "none",
          }}
        />
      )}
    </Box>
  );
}
